import { render } from "./AssistantAdminsList.vue?vue&type=template&id=7e4fa951"
import script from "./AssistantAdminsList.vue?vue&type=script&lang=js"
export * from "./AssistantAdminsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__